import { mapGetters, mapMutations } from "vuex";
import alertHelper from "@/helper/AlertHelper";

export const shetabValidationMixin = {
  data() {
    return {
      smsConfirmCode: "",
      nationalCode: "",
      mobileNumber: "",
      paymentId: "",
      querySecret: "",
      continuousCreditCardNumber: "",
      otpInputReadOnly: false,
    };
  },
  computed: {
    ...mapGetters([
      "getTransactionId",
      "getMobileNumber",
      "getCompleteCreditCardNumber",
      "getShetabSelectedPayingAmount",
      "getPaymentMethod",
      "getNationalCodeNeeded",
      "getVersion",
    ]),
  },
  methods: {
    ...mapMutations([
      "setStepperPage",
      "setTransactionId",
      "setNationalCodeNeeded",
    ]),
    eraseCode() {
      this.smsConfirmCode = "";
    },
    lockOtpInput(condition) {
      this.otpInputReadOnly = condition;
    },

    submitOTP() {
      if (this.smsConfirmCode === "") {
        alertHelper.errorAlert("", "کد ارسال شده را وارد کنید");
      } else if (this.getNationalCodeNeeded && !this.nationalCode) {
        alertHelper.errorAlert("", "کد ملی را وارد کنید");
      } else {
        alertHelper.loadingAlert();
        let transactionId = this.getTransactionId;
        this.$http
          .post(`transactions/${transactionId}/otp-verify`, {
            otp_code: this.smsConfirmCode,
            national_code: this.nationalCode,
          })
          .then(
            (result) => {
              if (result.status === 200 || result.status + "" === "Success") {
                alertHelper.successAlert();
                this.$router.push(
                  `/shetab/payment-info?id=${this.paymentId}&s=${this.querySecret}`
                );
              }
            },
            (error) => {
              if (
                error.body &&
                error.body.additional_info &&
                error.body.additional_info.code
              ) {
                if (error.body.additional_info.code === 3333) {
                  this.setNationalCodeNeeded(true);
                  this.lockOtpInput(true);
                  this.deactivateTimerEvent();
                  alertHelper.closeAlert()
                  alertHelper.infoAlert("", error.body.message);
                } else {
                  alertHelper.apiErrorAlert("", error.body.message);
                }
              } else {
                alertHelper.apiErrorAlert("", error.body.message);
                this.lockOtpInput(false);
              }
            }
          );
      }
    },
    changeNumber() {
      this.$router.push("/?id=" + `${this.paymentId}&s=${this.querySecret}`);
    },
    activateTimerEvent() {
      this.$refs.shetabValidationTimer.activeInterval();
    },
    deactivateTimerEvent() {
      this.$refs.shetabValidationTimer.clearInterval();
    },
    handleTimeExpired() {
      this.$swal({
        title: "توجه",
        text: " برای درخواست دوباره کد بر روی دکمه زیر کلیک کنید",
        icon: "danger",
        showConfirmButton: true,
        confirmButtonText: "درخواست دوباره",
        allowOutsideClick: true,
        customClass: {
          title: "alertTitleClass",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          alertHelper.loadingAlert();
          this.$http
            .post("transactions", {
              payment_id: this.paymentId,
              gateway: "SHETAB",
              amount: this.getShetabSelectedPayingAmount,
              from: this.getCompleteCreditCardNumber,
              mobile: this.getMobileNumber,
              method: this.getPaymentMethod,
            })
            .then(
              (result) => {
                if (result.status === 201) {
                  this.transactionId = result.data.data.id;
                  this.setTransactionId(this.transactionId);
                  if (result.data.data.gateway_result.hasToken === true) {
                    alertHelper.successAlert();
                    this.$router.push(
                      `/shetab/payment-info?id=${this.paymentId}&s=${this.querySecret}`
                    );
                  } else {
                    this.activateTimerEvent();

                    alertHelper.successAlert(
                      "",
                      "کد تایید به شماره موبایل شماارسال شد"
                    );
                  }
                }
              },
              (error) => {
                alertHelper.apiErrorAlert("", error.body.message);
              }
            );
        }
      });
    },
  },
  created() {
    this.setStepperPage("pageTwo");
    this.paymentId = this.$route.query.id;
    this.querySecret = this.$route.query.s;
  },
  mounted() {
    this.activateTimerEvent();
  },
  destroyed() {
    this.deactivateTimerEvent();
  },
};
